var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3444 18.6377C24.1808 19.9578 25.4675 21.7463 25.4675 24.1309V28.3893H30.8291V24.1309C30.8291 21.0366 26.0439 19.2055 22.3444 18.6377Z",
    fill: "#3BD7E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0635 17.0333C15.0247 17.0333 17.4251 14.4913 17.4251 11.3555C17.4251 8.21976 15.0247 5.67773 12.0635 5.67773C9.10243 5.67773 6.70197 8.21976 6.70197 11.3555C6.70197 14.4913 9.10243 17.0333 12.0635 17.0333Z",
    fill: "#3BD7E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1059 17.0333C23.0682 17.0333 25.4675 14.4925 25.4675 11.3555C25.4675 8.21854 23.0682 5.67773 20.1059 5.67773C19.4759 5.67773 18.8862 5.81968 18.3232 6.0184C19.4766 7.529 20.1059 9.41287 20.1059 11.3555C20.1059 13.2982 19.4766 15.182 18.3232 16.6926C18.8862 16.8913 19.4759 17.0333 20.1059 17.0333ZM12.0636 18.4527C8.4847 18.4527 1.34039 20.3548 1.34039 24.1305V28.3888H22.7867V24.1305C22.7867 20.3548 15.6424 18.4527 12.0636 18.4527Z",
    fill: "#3BD7E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeters);
export default __webpack_public_path__ + "static/media/meters.89eb31692423ec47eafc102c10c3d626.svg";
export { ForwardRef as ReactComponent };